import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableRow,
  Paper,
  Checkbox,
  Tooltip,
  Box,
  DialogContentText,
  TableFooter,
  Card,
  CardContent,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  EyeOutlined, PlayCircleOutlined,
  QuestionCircleOutlined, Html5Filled
} from "@ant-design/icons";
// import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";
import Select, { SelectChangeEvent } from "@mui/material/Select";
// import { border, height, width } from "@mui/system";
import HttpService from "../services/httpService";
import { CSVLink } from "react-csv";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import { ROLENAME } from '../utils';
// import axios from "axios";
const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 2,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "relative",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: 400,
    margin: "0 auto",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
    border: "1px solid #ddd", // Add border to the table
  },
  tableCell: {
    textAlign: "center",
    border: "1px solid #ddd", // Add border to table cells
    whiteSpace: "normal", // Allow wrapping of content
    wordWrap: "break-word", // Break words that exceed the width
    maxWidth: "150px", // Example maximum width
    padding: "5px", // Adjust padding as needed
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  downloadButton: {
    backgroundColor: '#355025',   // Dark Blue
    color: '#FFF2EB',             // White text
    '&:hover': {
      backgroundColor: '#4A6641', // Derived lighter Dark Blue
    },
  },
}));

function PerformanceForDesignTeam(props) {
  const { userDetails } = useSelector((state) => state.user);
  const findDgm = userDetails?.roles?.some((role) => role?.name?.includes("DGM Design"));
  const findSalesHead = userDetails?.roles?.some((role) =>
    role?.name?.includes("DesignHead")
  );
  const salesHeadAccess = (findDgm && findSalesHead) || findSalesHead;

  const classes = useStyles();
  //----------------New Requirement Code---------------
  const [radioValue, setRadioValue] = useState("NA");
  // const [monthFilter,setMonthFilter] = useState("")
  const [hierarchyData, setHierarchyData] = useState({});
  const [hierarchyCsvData, setHierarchyCsvData] = useState([]);
  const [adminData, setAdminData] = useState({});
  const [adminCsvData, setAdminCsvData] = useState([]);
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const [openPipDialog, setOpenPipDialog] = useState(false);
  const [pipUserInfo, setPipUserInfo] = useState({});
  const [openReasonDialog, setOpenReasonDialog] = useState(false);
  const [reasonText, setReasonText] = useState("");
  const [reasonHistory, setReasonHistory] = useState({});
  const [openReasonHistory, setOpenReasonHistory] = useState(false);
  const [pipNotification, setPipNotification] = useState({});
  const [selectExperienceCenter, setSelectExperienceCenter] = useState("all");
  const [allExeperienceCenter, setAllExperienceCenter] = useState({});
  const [hierarchyCsvHeader, setHierarchyCsvHeader] = useState([])
  const [adminCsvHeader, setAdminCsvHeader] = useState([])
  const [adminToggle, setAdminToggle] = useState(false)
  const [userType,setUserType] = useState(false)
  const [loading, setLoading]  = useState(false)

  // convert rs in comma saprator
  function formatRupees(amount) {
    const amountInLacs = amount / 100000;
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(amountInLacs);
  }

  function findMonthName(monthNumber) {
    const result =
      monthNumber === 1
        ? "Jan"
        : monthNumber === 2
        ? "Feb"
        : monthNumber === 3
        ? "March"
        : monthNumber === 4
        ? "Apr"
        : monthNumber === 5
        ? "May"
        : monthNumber === 6
        ? "June"
        : monthNumber === 7
        ? "July"
        : monthNumber === 8
        ? "Aug"
        : monthNumber === 9
        ? "Sept"
        : monthNumber === 10
        ? "Oct"
        : monthNumber === 11
        ? "Nov"
        : monthNumber === 12
        ? "Dec"
        : "Invalid month";
    // - {ele.year}

    return result;
  }

  function yearFilterHandle(e) {
    setYearFilter(e.target.value);
  }

  const currentMonth = new Date().getMonth();

  function flattenedDataFunHandle(data) {
    const flattenData = data?.map((item) => {
      return {
        name: item.name || "N/A",
        ec: item?.experienceCenters?.join(", ") || "N/A",
        designation: item?.roles?.join(", ") || "N/A",
        monthTarget1: item?.data[0]?.target || 0,
        monthTarget2: item?.data[1]?.target || 0,
        monthTarget3: item?.data[2]?.target || 0,
        monthAchievedAmount1: item?.data[0]?.achieved || 0,
        monthAchievedAmount2: item?.data[1]?.achieved || 0,
        monthAchievedAmount3: item?.data[2]?.achieved || 0,
        monthAchievedPercent1: item?.data[0]?.performancePercentage || 0,
        monthAchievedPercent2: item?.data[1]?.performancePercentage || 0,
        monthAchievedPercent3: item?.data[2]?.performancePercentage || 0,
      };
    });

    return flattenData || [];
  }

  useEffect(() => {
    const emptyRow = {
      name: "",
      ec: "",
      role: "",
      monthTarget1: "", // Ensure value exists, otherwise default to 0
      monthTarget2: "",
      monthTarget3: "",
      monthAchievedAmount1: "",
      monthAchievedAmount2: "",
      monthAchievedAmount3: "",
      monthAchievedPercent1: "",
      monthAchievedPercent2: "",
      monthAchievedPercent3: "",
    };

    // admin falttend data
    if (
      userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      )
    ) {
      const forAdminVisibilityDgmFlattenData = flattenedDataFunHandle(
        adminData?.data?.dgmData
      );
      const forAdminVisibilityAgmFlattenData = flattenedDataFunHandle(
        adminData?.data?.agmData
      );
      const forAdminVisibilitySmFlattenData = flattenedDataFunHandle(
        adminData?.data?.dmData
      );
      const forAdminVisibilityAsmFlattenData = flattenedDataFunHandle(
        adminData?.data?.admData
      );
      const forAdminVisibilitySeFlattenData = flattenedDataFunHandle(
        adminData?.data?.executiveData
      );

      if (radioValue === "all") {
        setAdminCsvData([
          ...forAdminVisibilityDgmFlattenData,
          emptyRow,
          ...forAdminVisibilityAgmFlattenData,
          emptyRow,
          ...forAdminVisibilitySmFlattenData,
          emptyRow,
          ...forAdminVisibilityAsmFlattenData,
          emptyRow,
          ...forAdminVisibilitySeFlattenData,
        ]);
      } else if (radioValue === "DGM") {
        setAdminCsvData(forAdminVisibilityDgmFlattenData);
      } else if (radioValue === "AGM") {
        setAdminCsvData(forAdminVisibilityAgmFlattenData);
      } else if (radioValue === "ODM") {
        setAdminCsvData(forAdminVisibilitySmFlattenData);
      } else if (radioValue === "ADM") {
        setAdminCsvData(forAdminVisibilityAsmFlattenData);
      } else if (radioValue === "DE") {
        setAdminCsvData(forAdminVisibilitySeFlattenData);
      }
    }
    // Hierarchy falttend data
    else {
      const hierarchyDgmFlattenData = flattenedDataFunHandle(
        hierarchyData?.data?.dgmData
      );
      const hierarchyAgmFlattenData = flattenedDataFunHandle(
        hierarchyData?.data?.agmData
      );
      const hierarchySmFlattenData = flattenedDataFunHandle(
        hierarchyData?.data?.dmData
      );
      const hierarchyAsmFlattenData = flattenedDataFunHandle(
        hierarchyData?.data?.admData
      );
      const hierarchySeFlattenData = flattenedDataFunHandle(
        hierarchyData?.data?.executiveData
      );

      if (radioValue === "NA") {
        setHierarchyCsvData([
          ...hierarchyDgmFlattenData,
          emptyRow,
          ...hierarchyAgmFlattenData,
          emptyRow,
          ...hierarchySmFlattenData,
          emptyRow,
          ...hierarchyAsmFlattenData,
          emptyRow,
          ...hierarchySeFlattenData,
        ]);
      } else if (radioValue === "DGM") {
        setHierarchyCsvData(hierarchyDgmFlattenData);
      } else if (radioValue === "AGM") {
        setHierarchyCsvData(hierarchyAgmFlattenData);
      } else if (radioValue === "ODM") {
        setHierarchyCsvData(hierarchySmFlattenData);
      } else if (radioValue === "ADM") {
        setHierarchyCsvData(hierarchyAsmFlattenData);
      } else if (radioValue === "DE") {
        setHierarchyCsvData(hierarchySeFlattenData);
      }
    }
  }, [hierarchyData, radioValue, adminData]);

  // hierarchy Data
  async function hierarchyWiseGetDataHandle(userId, year) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.performanceHierarchyWiseForDesign(
        userId,
        year
      );
      setHierarchyData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  // admin data
  async function adminGetDataHandle(year, ecId,isDeactivatedToggle) {
    try {
      setLoading(true)
      // props.setLoading(true);
      const fetchData = await HttpService.performanceVisiabilityForAdminForDesign(
        year,
        ecId,
        isDeactivatedToggle
      );
      setAdminData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }finally{
      setLoading(false)
    }
  }

  // pip send api

  async function sendPipHandle(userId) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.sendPipApi(userId);
      props.setSnackInfo(fetchData?.data?.message);
      props.setLoading(false);
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message, "error");
      props.setLoading(false);
    }
  }

  // reason send api
  async function notSendPipHandle(userId, obj) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.notSendReasonPipApi(userId, obj);
      props.setSnackInfo(fetchData?.data?.message);
      props.setLoading(false);
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message, "error");
      props.setLoading(false);
    }
  }

  // reason history get api
  async function reasonHistoryApiHandle(userId) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.reasonHistoryApi(userId);
      setReasonHistory(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setSnackInfo(error?.response?.data?.message, "error");
      props.setLoading(false);
    }
  }

  // Get All Experience Center

  async function getExperienceCenterHandleFun() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAllExperienceCenter();
      setAllExperienceCenter(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }


  //  PIP SHOWING ALERT..
  useEffect(() => {
    const pipNotificationHandle = async (userId) => {
      if (!userId) return;
      try {
        props.setLoading(true);
        const fetchData = await HttpService.pipNotificationApi(userId);
        setPipNotification(fetchData.data);
      } catch (error) {
        console.error("Error fetching PIP data:", error);
      } finally {
        props.setLoading(false);
      }
    };

    if (userDetails?._id) {
      pipNotificationHandle(userDetails._id);
    }
  }, [userDetails?._id]);



  // Color Coding
  const getPerformanceColor = (percentage) => {
    if (percentage === undefined || percentage === null) return "gray"; // Default color
    if (percentage >= 100) return "darkgreen";
    if (percentage >= 80) return "lightgreen";
    if (percentage >= 50) return "yellow";
    return "red";
  };

  // Short Year

  const shortYear = (year)=>{
    return year % 100;

  }

  useEffect(() => {
    if (
      userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      )
    ) {
      adminGetDataHandle(yearFilter, selectExperienceCenter,userType);
      getExperienceCenterHandleFun();
    } else {
      hierarchyWiseGetDataHandle(userDetails?._id, yearFilter);
    }
  }, [yearFilter, selectExperienceCenter, userDetails,userType]);


  useEffect(() => {
    setHierarchyCsvHeader([
      { key: "name", label: "Name" },
      { key: "ec", label: "Experience-Center" },
      { key: "designation", label: "Designation" },
      {
        key: "monthTarget1",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[0]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[0]?.year}--target`,
      },
      {
        key: "monthTarget2",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[1]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[1]?.year}-target`,
      },
      { key: "monthTarget3", label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[2]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[2]?.year}-target` },
      {
        key: "monthAchievedAmount1",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[0]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[0]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedAmount2",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[1]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[1]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedAmount3",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[2]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[2]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedPercent1",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[0]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[0]?.year}-Achieved(percent)`,
      },
      {
        key: "monthAchievedPercent2",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[1]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[1]?.year}-Achieved(percent)`,
      },
      {
        key: "monthAchievedPercent3",
        label: `${findMonthName(hierarchyData?.data?.executiveData[0]?.data[2]?.month)}-${hierarchyData?.data?.executiveData[0]?.data[2]?.year}-Achieved(percent)`,
      },
    ])
    setAdminCsvHeader([
      { key: "name", label: "Name" },
      { key: "ec", label: "Experience-Center" },
      { key: "designation", label: "Designation" },
      {
        key: "monthTarget1",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[0]?.month)}-${adminData?.data?.executiveData[0]?.data[0]?.year}-target`,
      },
      {
        key: "monthTarget2",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[1]?.month)}-${adminData?.data?.executiveData[0]?.data[1]?.year}-target`,
      },
      { key: "monthTarget3", label: `${findMonthName(adminData?.data?.executiveData[0]?.data[2]?.month)}-${adminData?.data?.executiveData[0]?.data[2]?.year}-target` },
      {
        key: "monthAchievedAmount1",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[0]?.month)}-${adminData?.data?.executiveData[0]?.data[0]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedAmount2",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[1]?.month)}-${adminData?.data?.executiveData[0]?.data[1]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedAmount3",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[2]?.month)}-${adminData?.data?.executiveData[0]?.data[2]?.year}-Achieved(amount)`,
      },
      {
        key: "monthAchievedPercent1",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[0]?.month)}-${adminData?.data?.executiveData[0]?.data[0]?.year}-Achieved(percent)`,
      },
      {
        key: "monthAchievedPercent2",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[1]?.month)}-${adminData?.data?.executiveData[0]?.data[1]?.year}-Achieved(percent)`,
      },
      {
        key: "monthAchievedPercent3",
        label: `${findMonthName(adminData?.data?.executiveData[0]?.data[2]?.month)}-${adminData?.data?.executiveData[0]?.data[2]?.year}-Achieved(percent)`,
      },
    ])
  }, [hierarchyData, adminData])


  // Select Radio Button Logic
  useEffect(()=>{
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.DGM_Design)){
      setRadioValue("DGM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AGM_Design)){
      setRadioValue("AGM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.OperationDesignManager)){
      setRadioValue("ODM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AssistantDesignManager)){
      setRadioValue("ADM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.DesignUser)){
      setRadioValue("DE")
    }
  },[userDetails])

  const currentYear = new Date().getFullYear();
  const financialYears = [
      { value: currentYear - 2, label: `${currentYear - 2}` },
      { value: currentYear - 1, label: `${currentYear - 1}` },
      { value: currentYear, label: `${currentYear}` },
  ];
  //  loader beautiful
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "60vh",
          fontSize: "1.5rem",
          fontWeight: "500",
          color: "#1976d2",
          fontFamily: "sans-serif",
          letterSpacing: "0.5px"
        }}
      >
        <div
          style={{
            fontSize: "3rem",
            animation: "flip 1.2s infinite linear",
            display: "inline-block"
          }}
        >
          ⏳
        </div>
        <div style={{ marginTop: "10px" }}>Loading...</div>
    
        {/* Hourglass flip animation */}
        <style>
          {`
            @keyframes flip {
              0% { transform: rotate(0deg); }
              25% { transform: rotateX(180deg); }
              50% { transform: rotate(180deg); }
              75% { transform: rotateX(360deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex" }}>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="demo-select-small-label">Choose Year</InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={yearFilter}
              label="Select year"
              onChange={yearFilterHandle}
            >
              {/* <MenuItem value={2022}>{2022}</MenuItem> */}
              {financialYears.map((year) => (
                <MenuItem key={year.value} value={year.value}>
                  {year.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* ------------experience Center option------- */}
          {userDetails?.roles?.some(
            (role) =>
              role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
          ) && (
              <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                <InputLabel id="experience-center-label">
                  Choose EC
                </InputLabel>
                <Select
                  labelId="experience-center-label"
                  id="experience-center-select"
                  value={selectExperienceCenter}
                  label="Experience Center"
                  onChange={(e) => setSelectExperienceCenter(e.target.value)}
                >
                  {/* Default Option */}
                  <MenuItem value="all">All</MenuItem>

                  {/* Render Options Dynamically */}
                  {userDetails?.roles?.some(
                    (role) =>
                      role?.name?.includes("Admin") ||
                      role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
                  ) &&
                    allExeperienceCenter?.data?.length > 0 &&
                    allExeperienceCenter.data.map((ele) => (
                      <MenuItem key={ele?._id} value={ele?._id}>
                        {ele.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}

          {/* choosing Active / Inactive  User Type*/}
          {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager"))) &&
            (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="user-type-label">User Type</InputLabel>
                <Select
                  labelId="user-type-label"
                  id="user-type"
                  value={userType}
                  label="User Type"
                  onChange={(e) => setUserType(e.target.value)}
                >
                  <MenuItem value="false">Active</MenuItem>
                  <MenuItem value="true">Inactive</MenuItem>
                </Select>
              </FormControl>
            )}

          {/* ----------------Radio buttons------------------ */}
          {!userDetails?.roles?.some((role) =>
            role?.name?.includes("Design User") || role?.name?.includes("Admin") || role?.name === ROLENAME.CenterHead || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
          ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);
                    }}
                  >
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")    
                    ) && (
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All"
                      />
                      )} 
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="DGM"
                          control={<Radio />}
                          label="DGM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                      {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ODM"
                          control={<Radio />}
                          label="ODM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("Design Head") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Assistant Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel value="ADM" control={<Radio />} label="ADM" />
                      )}
                    <FormControlLabel value="DE" control={<Radio />} label="DE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}

          {/*  new.... */}
          {
            userDetails?.roles?.find(role => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
            ) && (
              <Box>
                <FormControl
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <FormLabel
                    id="demo-radio-buttons-group-label"
                    sx={{ marginLeft: "10px", marginRight: "10px" }}
                  >
                    Select Role
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={radioValue}
                    name="radio-buttons-group"
                    sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                    onChange={(e) => {
                      setRadioValue(e.target.value);
                      setAdminToggle(true)
                    }}
                  >


                    <FormControlLabel
                      value="all"
                      control={<Radio />}
                      label="All"
                    />


                    <FormControlLabel
                      value="DGM"
                      control={<Radio />}
                      label="DGM"
                    />

                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="AGM"
                          control={<Radio />}
                          label="AGM"
                        />
                      )}
                       {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ODM"
                          control={<Radio />}
                          label="ODM"
                        />
                      )}
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Design") ||
                        role?.name?.includes("DesignHead") ||
                        role?.name?.includes("AGM Design") ||
                        role?.name?.includes("Operation Design Manager") ||
                        role?.name?.includes("Assistant Design Manager") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") ||
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <FormControlLabel
                          value="ADM"
                          control={<Radio />}
                          label="ADM"
                        />
                      )}
                   
                    <FormControlLabel value="DE" control={<Radio />} label="DE" />
                  </RadioGroup>
                </FormControl>
              </Box>
            )}
        </Box>
        {/*--------------------- Legends----------- */}
        {!userDetails?.roles?.some(
          (role) =>
            role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
        ) &&
          hierarchyCsvData?.length > 0 && hierarchyCsvHeader.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
            >
              <CSVLink
                data={hierarchyCsvData || []}
                headers={hierarchyCsvHeader || []}
                filename={`performance of ${yearFilter}`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  // fontSize: "15px",
                }}
              >
                Download CSV Data
              </CSVLink>
            </Button>
          )}

        {userDetails?.roles?.some(
          (role) =>
            role?.name?.includes("Admin") || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
        ) &&
          adminCsvData?.length > 0 && adminCsvHeader?.length > 0 && (
            <Button
              variant="contained"
              color="primary"
              style={{
                height: "40px",
                marginTop: "6px",
                marginLeft: "8px",
                fontSize: "12px",
              }}
              className={classes.downloadButton}
            >
              <CSVLink
                data={adminCsvData || []}
                headers={adminCsvHeader || []}
                filename={`performance of ${yearFilter}`}
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  // fontSize: "15px",
                }}
              >
                Download CSV Data
              </CSVLink>
            </Button>
          )}

      </Box>
      <Box style={{ textAlign: "right" }} >
        <b style={{
        }}>
          All the amounts are shown in lacs ( ₹ )
        </b>
        {JSON.stringify(pipNotification) !== "{}" && (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              backgroundColor: "#ffe6e6", // Light red background for alert
              border: "1px solid #ffcccc", // Border to define the alert box
              color: "red",
              marginTop: "15px",
              padding: "15px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "16px",

            }}
          >
            <Box style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
              <span
                style={{
                  marginRight: "10px",
                  fontSize: "25px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                ⚠️
              </span>
              <b>You are under PIP due to not achieving 80% of your target for the past three months. Please check your email for more info.</b>
            </Box>
            <Box style={{ color: "#333", fontSize: "14px", fontWeight: 400 }}>
              Remember, this is an opportunity to grow and improve. Take it as a challenge to showcase your potential and turn things around. We're rooting for you!
            </Box>
          </Box>
        )}
        <Box
          style={{
            display: "flex",
            gap: "10px",
            marginTop: "15px",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          {[
            { percent: ">=100%", color: "darkgreen" },
            { percent: ">=80%", color: "lightgreen" },
            { percent: ">=50%", color: "yellow" },
            { percent: "<50%", color: "red" },
          ].map((ele) => {
            return (
              <Box>
                <Box
                  style={{
                    borderRadius: "7px",
                    width: "70px",
                    height: "20px",
                    backgroundColor: ele.color,
                    textAlign: "center",
                  }}
                >
                  <b>{ele.percent}</b>
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>



      {/* -------------------------- New Requirement Code------------------------ */}
      {userDetails?.roles?.some(
        (role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head") ||
        role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        radioValue !== "NA" && 
        !adminData?.data?.dgmData?.length &&
        !adminData?.data?.agmData?.length &&
        !adminData?.data?.dmData?.length &&
        !adminData?.data?.admData?.length &&
        !adminData?.data?.executiveData?.length && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilter}
          </div>
        )}


      {!userDetails?.roles?.some(
        (role) =>
          role?.name?.includes("Admin") || role?.name?.includes("Center Head") ||
          role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !hierarchyData?.data?.dgmData?.length > 0 &&
        !hierarchyData?.data?.agmData?.length > 0 &&
        !hierarchyData?.data?.dmData?.length > 0 &&
        !hierarchyData?.data?.admData?.length > 0 &&
        !hierarchyData?.data?.executiveData?.length > 0 && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilter}
          </div>
        )}
      {/* -----------------DGM Table for Admin-------------------------------------- */}
      {userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(adminData) !== "{}" &&
        adminData?.data?.dgmData?.length > 0 &&
        (radioValue === "all" || radioValue === "DGM") && (
          <div>
            <h3>DGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc",width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv

                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                    Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminData) !== "{}" &&
                    adminData?.data?.dgmData?.length > 0 &&
                    adminData?.data?.dgmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name?.includes("Admin") ||
                              role?.name?.includes("Center Head") ||
                              role?.name?.includes("Finance Executive") || 
                              role?.name?.includes("Finance User") || 
                              role?.name?.includes("Finance Manager")
                          ) && (
                              <TableCell className={classes.tableCell} >
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.isPipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    Send PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.isPipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px",marginLeft:"4px"}}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------AGM Table for Admin-------------------------------------- */}
      {userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") ||role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(adminData) !== "{}" &&
        adminData?.data?.agmData?.length > 0 &&
        (radioValue === "all" || radioValue === "AGM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>AGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc",width:"60px"  }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}>
                      {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv
                      </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                    Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") || 
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminData) !== "{}" &&
                    adminData?.data?.agmData?.length > 0 &&
                    adminData?.data?.agmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name?.includes("Admin") ||
                              role?.name?.includes("Center Head") || 
                              role?.name?.includes("Finance Executive") || 
                              role?.name?.includes("Finance User") || 
                              role?.name?.includes("Finance Manager")
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.isPipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.isPipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------ODM Table for Admin-------------------------------------- */}
      {userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(adminData) !== "{}" &&
        adminData?.data?.dmData?.length > 0 &&
        (radioValue === "all" || radioValue === "ODM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ODM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" ,width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv

                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                    Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminData) !== "{}" &&
                    adminData?.data?.dmData?.length > 0 &&
                    adminData?.data?.dmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>

                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name?.includes("Admin") ||
                              role?.name?.includes("Center Head") || 
                              role?.name?.includes("Finance Executive") || 
                              role?.name?.includes("Finance User") || 
                              role?.name?.includes("Finance Manager")
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.isPipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.isPipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------ADM Table for Admin-------------------------------------- */}
      {userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(adminData) !== "{}" &&
        adminData?.data?.admData?.length > 0 &&
        (radioValue === "all" || radioValue === "ADM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ADM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" ,width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv

                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(adminData?.data?.dgmData[0]?.data[2]?.year)} <br />
                    Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminData) !== "{}" &&
                    adminData?.data?.admData?.length > 0 &&
                    adminData?.data?.admData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>

                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name?.includes("Admin") ||
                              role?.name?.includes("Center Head") ||
                              role?.name?.includes("Finance Executive") || 
                              role?.name?.includes("Finance User") || 
                              role?.name?.includes("Finance Manager")
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.isPipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.isPipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------DE Table for Admin-------------------------------------- */}
      {userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(adminData) !== "{}" &&
        adminData?.data?.executiveData?.length > 0 &&
        (radioValue === "all" || radioValue === "DE") && (
          <div>
            <h3 style={{marginTop:"12px"}}>DE Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc",width:"60px"  }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Acv

                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {adminData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {adminData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(adminData?.data?.executiveData[0]?.data[2]?.year)} <br />
                    Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminData) !== "{}" &&
                    adminData?.data?.executiveData?.length > 0 &&
                    adminData?.data?.executiveData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name?.includes("Admin") ||
                              role?.name?.includes("Center Head") || 
                              role?.name?.includes("Finance Executive") || 
                              role?.name?.includes("Finance User") || 
                              role?.name?.includes("Finance Manager")
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.isPipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.isPipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------DGM Table Hierarchy-------------------------------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.dgmData?.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DGM") && (
          <div>
            <h3>DGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc",width:"60px"  }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {hierarchyData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dgmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dgmData[0]?.data[2]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("Finance Executive") || 
                        role?.name?.includes("Finance User") || 
                        role?.name?.includes("Finance Manager")
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.dgmData?.length > 0 &&
                    hierarchyData?.data?.dgmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            <Tooltip
                              title={ele?.experienceCenters?.join(", ") || ""}
                              arrow
                              placement="top"
                            >
                              <span>
                                {ele?.experienceCenters
                                  ?.slice(0, 2)
                                  .map((ec, index, array) => {
                                    const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                    return (
                                      <span key={index}>
                                        {truncatedEc}
                                        {index < array.length - 1 ? ", " : ""}
                                      </span>
                                    );
                                  })}
                                {ele?.experienceCenters?.length > 2 ? ".." : ""}
                              </span>
                            </Tooltip>
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------AGM Table Hierarchy-------------------------------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.agmData?.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "AGM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>AGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc",width:"60px"  }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[0]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {hierarchyData?.data?.agmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.agmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.agmData[0]?.data[2]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) => role?.name === "DGM Design"
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.agmData?.length > 0 &&
                    hierarchyData?.data?.agmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            {ele?.experienceCenters.map((ec, index, array) => {
                              return (
                                <span key={index}>
                                  {ec}
                                  {index < array.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) => role?.name === "DGM Design"
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.pipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.pipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------ODM Table Hierarchy-------------------------------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.dmData?.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ODM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ODM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" ,width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[0]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {hierarchyData?.data?.dmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.dmData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.dmData[0]?.data[2]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) => role?.name === "DGM Design" || role?.name === "Operation Design Manager"
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.dmData?.length > 0 &&
                    hierarchyData?.data?.dmData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            {ele?.experienceCenters.map((ec, index, array) => {
                              return (
                                <span key={index}>
                                  {ec}
                                  {index < array.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) => role?.name === "DGM Design" || role?.name === "Operation Design Manager"
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.pipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.pipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------ADM Table Hierarchy-------------------------------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.admData?.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ADM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ADM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" ,width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[0]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {hierarchyData?.data?.admData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.admData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.admData[0]?.data[2]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name === "DGM Design" ||
                        role?.name === "Design Manager" ||
                        role?.name === "Operation Design Manager"
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.admData?.length > 0 &&
                    hierarchyData?.data?.admData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            {ele?.experienceCenters.map((ec, index, array) => {
                              return (
                                <span key={index}>
                                  {ec}
                                  {index < array.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name === "DGM Design" ||
                              role?.name === "Design Manager" ||
                              role?.name === "Operation Design Manager"
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.pipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.pipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------DE Table Hierarchy-------------------------------------- */}
      {!userDetails?.roles?.some(
        (role) =>
          (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head") || role?.name?.includes("Finance Executive") || role?.name?.includes("Finance User") || role?.name?.includes("Finance Manager")
      ) &&
        !JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.executiveData?.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DE") && (
          <div>
            <h3 style={{marginTop:"12px"}}>DE Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  {/* Main header row */}
                  <TableRow style={{ backgroundColor: "red" }}>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" ,width:"60px" }}
                    >
                      Exp Center
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Target
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[2]?.year)} <br />
                      Target
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                    {hierarchyData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Acv
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[2]?.year)} <br />
                      Acv
                    </TableCell>

                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[0]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[0]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[1]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[1]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      {hierarchyData?.data?.executiveData[0]?.data[2]?.month}-{shortYear(hierarchyData?.data?.executiveData[0]?.data[2]?.year)} <br />
                      Acv (%)
                    </TableCell>
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name === "DGM Design" ||
                        role?.name === "Design Manager" ||
                        role?.name === "Operation Design Manager"
                    ) && (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.executiveData?.length > 0 &&
                    hierarchyData?.data?.executiveData.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.name}
                          </TableCell>
                          <TableCell>
                            {ele?.experienceCenters.map((ec, index, array) => {
                              return (
                                <span key={index}>
                                  {ec}
                                  {index < array.length - 1 ? ", " : ""}
                                </span>
                              );
                            })}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.target)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[0]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[1]?.achieved)}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {formatRupees(ele?.data[2]?.achieved)}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[0]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[0]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[1]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[1]?.performancePercentage}
                          </TableCell>
                          <TableCell
                            className={classes.tableCell}
                            style={{
                              backgroundColor: getPerformanceColor(ele?.data[2]?.performancePercentage),
                              fontWeight: 800,
                            }}
                          >
                            {ele?.data[2]?.performancePercentage}
                          </TableCell>
                          {userDetails?.roles?.some(
                            (role) =>
                              role?.name === "DGM Design" ||
                              role?.name === "Design Manager" ||
                              role?.name === "Operation Design Manager"
                          ) && (
                              <TableCell className={classes.tableCell}>
                                <Box>
                                  <EyeOutlined
                                    style={{
                                      // marginTop: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      reasonHistoryApiHandle(ele?.userId);
                                      setPipUserInfo(ele);
                                      setOpenReasonHistory(true);
                                    }}
                                  />
                                </Box>
                                {!(ele?.PIP == true && ele.pipSent == true) ? (
                                  <Button
                                    variant="contained"
                                    disabled={!ele?.PIP}
                                    style={{ fontSize: "10px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenPipDialog(true);
                                      // sendPipHandle(ele.userId);
                                    }}
                                  >
                                    SEND PIP
                                    {/* {(!(ele?.PIP==true && ele.isPipSent==true))?" Initiate PIP":"Under PIP"} */}
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    disabled={true}
                                    style={{ fontSize: "10px", color: "red" }}
                                  >
                                    Under PIP
                                  </Button>
                                )}

                                {ele?.PIP == true && ele.pipSent == false && (
                                  <Button
                                    variant="contained"
                                    style={{ fontSize: "10px", marginLeft: "4px" }}
                                    onClick={() => {
                                      setPipUserInfo(ele);
                                      setOpenReasonDialog(true);
                                    }}
                                  >
                                    Reason
                                  </Button>
                                )}
                              </TableCell>
                            )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* ---------------Dialog Box for PIP------------------ */}
      <Dialog
        open={openPipDialog}
        onClose={() => {
          setOpenPipDialog(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "40%", // Set custom width
            maxHeight: "80vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          Are you sure you want to give pip to {pipUserInfo?.name}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              sendPipHandle(pipUserInfo?.userId);
              setOpenPipDialog(false);
              if (
                userDetails?.roles?.some(
                  (role) =>
                    role?.name?.includes("Admin") ||
                    role?.name?.includes("Center Head") ||
                    role?.name?.includes("Finance Executive") || 
                    role?.name?.includes("Finance User") || 
                    role?.name?.includes("Finance Manager")
                )
              ) {
                adminGetDataHandle(yearFilter, selectExperienceCenter,userType);
              } else {
                hierarchyWiseGetDataHandle(userDetails?._id, yearFilter);
              }
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              setOpenPipDialog(false);
            }}
            variant="contained"
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ---------------Dialog Box for reason--------------- */}
      <Dialog
        open={openReasonDialog}
        onClose={() => {
          setOpenReasonDialog(false);
        }}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "40%", // Set custom width
            maxHeight: "80vh", // Optionally limit height
          },
        }}
      >
        <DialogContent>
          <TextField
            margin="dense"
            name="Reason"
            label={`write a reason to not give PIP ${pipUserInfo?.name}`}
            multiline
            rows={4} // Number of rows for the textarea
            fullWidth
            variant="outlined"
            value={reasonText}
            onChange={(e) => {
              setReasonText(e?.target?.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              notSendPipHandle(pipUserInfo?.userId, {
                reason: reasonText,
              });
              setReasonText("");
              setOpenReasonDialog(false);
            }}
          >
            Save
          </Button>
          <Button
            onClick={() => {
              setOpenReasonDialog(false);
            }}
            variant="contained"
            color="primary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ---------------Dialog Box for reason history--------------- */}

      <Dialog
        open={openReasonHistory && reasonHistory?.data}
        onClose={(event, reason) => {
          // Prevent closing the dialog when clicking outside or pressing "Escape"
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          setOpenReasonHistory(false);
        }}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "60%",
            maxHeight: "80vh",
            borderRadius: "12px",
            padding: "20px",
            overflow: "hidden", // Ensures scrolling works properly
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <DialogContent style={{ overflowY: "auto", paddingRight: "10px" }}>
          {/* Header Section */}
          <Box style={{ marginBottom: "20px" }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                color: "#333",
                textAlign: "center",
                borderBottom: "3px solid orange",
                paddingBottom: "8px",
              }}
            >
              {pipUserInfo?.name}'s PIP Not Sent Reason History
            </Typography>
          </Box>

          {/* Content Section */}
          {JSON.stringify(reasonHistory) !== "{}" &&
            reasonHistory?.data?.length > 0 ? (
            reasonHistory?.data?.map((ele, index) => (
              <Box
                key={index}
                style={{
                  marginBottom: "15px",
                  padding: "15px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Typography
                  variant="body1"
                  style={{ fontWeight: "bold", color: "#555" }}
                >
                  Reason: {ele.reason}
                </Typography>
                <Typography
                  variant="body2"
                  style={{
                    color: "#777",
                    marginTop: "5px",
                  }}
                >
                  {findMonthName(ele.month)} {ele.day}, {ele.year}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography
              variant="body1"
              style={{ textAlign: "center", color: "#999" }}
            >
              No history found for the user.
            </Typography>
          )}
        </DialogContent>

        {/* Footer Section */}
        <DialogActions>
          <Button
            onClick={() => {
              setOpenReasonHistory(false);
              setReasonHistory({});
            }}
            variant="contained"
            color="primary"
            style={{ fontWeight: "bold", textTransform: "none" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default connect(null, { setLoading, setSnackInfo })(PerformanceForDesignTeam);
